import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import ProjectDurationSettingsRepository from "../repositories/ProjectDurationSettingsRepository";
import { useCurrentCustomerName, useCurrentSiteId } from "./project";
export const useProjectDurationSettings = (client) => {
    const currentCustomerName = useCurrentCustomerName();
    const currentSiteId = useCurrentSiteId();
    const { data: projectDurationSettings, isLoading: isProjectDurationSettingsLoading } = useQuery({
        queryKey: ["project-duration-settings", currentCustomerName, currentSiteId],
        queryFn: () => ProjectDurationSettingsRepository(client).loadProjectDurationSettings(currentCustomerName, currentSiteId),
    });
    return { projectDurationSettings, isProjectDurationSettingsLoading };
};
export const useUpdateProjectDurationSettings = (client) => {
    const currentCustomerName = useCurrentCustomerName();
    const currentSiteId = useCurrentSiteId();
    const queryClient = useQueryClient();
    const { mutateAsync: updateProjectDurationSettings, isError: isUpdateError } = useMutation({
        mutationFn: (projectDurationSettingsToUpdate) => ProjectDurationSettingsRepository(client).updateProjectDurationSettings(currentCustomerName, currentSiteId, projectDurationSettingsToUpdate),
        onSuccess: (updatedProjectDurationSettings) => {
            queryClient.setQueryData(["project-duration-settings", currentCustomerName, currentSiteId], updatedProjectDurationSettings);
        },
    });
    return { updateProjectDurationSettings, isUpdateError };
};
export const usePublicHolidays = (countryCode, zipCode, year, client) => {
    const { data: publicHolidaysResponse, isLoading: arePublicHolidaysLoading } = useQuery({
        queryKey: ["public-holidays", countryCode, zipCode, year],
        queryFn: () => ProjectDurationSettingsRepository(client).loadPublicHolidays(countryCode, zipCode, year.value),
    });
    return { publicHolidaysResponse, arePublicHolidaysLoading };
};
//# sourceMappingURL=projectDurationSettings.js.map